<template>
  <div class="w-100 h-100 login-banner">
  </div>
</template>

<script>
export default {
  name: "Banner"
}
</script>

<style lang="scss">
@import "src/styles/modules/UI/Banner.scss";
</style>